import {
    request,
    requestPublic
} from './request.js'
// 获取专业列表页（成教、网教、自考)
export function getMajorPageList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/Major/GetMajorPageList',
        method: 'get',
        params: {
            MajorCategoryId: obj.majorCategoryId,
            Name: obj.name,
            PageIndex: obj.pageIndex,
            PageSize: obj.pageSize,
        }
    })
}
// 获取专业详情(成教、网教、自考)
export function getMajorDetail(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Major/GetMajorDetail',
        method: 'get',
        params: {
            id: id
        }
    })
}

// 添加专业(成教、网教、自考)
export function addMajor(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Major/AddMajor',
        method: 'post',
        data: data
    })
}

// 修改专业(成教、网教、自考)
export function updateMajor(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Major/UpdateMajor',
        method: 'post',
        data: data
    })
}

// 删除专业(成教、网教、自考)
export function delMajor(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Major/DelMajor',
        method: 'post',
        params: {
            id: id
        }
    })
}